import { render } from "./EventList.vue?vue&type=template&id=a151c530&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=ts"
export * from "./EventList.vue?vue&type=script&lang=ts"

import "./EventList.vue?vue&type=style&index=0&id=a151c530&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a151c530"

export default script